import { AfterViewInit, Directive, DoCheck, ElementRef, OnDestroy, Renderer2, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { DeviceService } from '../services/device.service';
import { DeviceSize } from '../data/device.data';

type GridColsType = 'repeat(6, 1fr)' | 'repeat(12, 1fr)';

@Directive({
    standalone: true,
    selector: '[siriusAutoGrid]',
})
export class AutoGridDirective implements AfterViewInit, DoCheck, OnDestroy {
    private _renderer = inject(Renderer2);
    private _elRef = inject(ElementRef);
    private deviceService = inject(DeviceService);

    private deviceSize: DeviceSize = DeviceSize.MD;
    private subscription: Subscription;

    private get style(): GridColsType {
        return [DeviceSize.SM, DeviceSize.MD].includes(this.deviceSize)
            ? 'repeat(6, 1fr)'
            : 'repeat(12, 1fr)';
    }

    constructor() {
        this.subscription = this.deviceService.deviceSize$.subscribe((deviceSize) => {
            this.deviceSize = deviceSize;
            this.setGridsFluid();
        });
    }

    ngAfterViewInit(): void {
        this.setGridsFluid();
    }

    ngDoCheck(): void {
        this.setGridsFluid();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private setGridsFluid(): void {
        const grids = this._elRef.nativeElement.querySelectorAll('sirius-grid');

        grids.forEach((el: HTMLElement) => {
            if (el.style.gridTemplateColumns === this.style) return;

            this._renderer.setStyle(el, 'grid-template-columns', this.style);
        });
    }
}
